import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ProductionBomEditView from '@components/shared/production_boms/ProductionBomEditView';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import PageHeader from '@shared/PageHeader';
import { useTranslation } from 'react-i18next';

import operatorProductionBomService from '@services/operator/productionBomService';

function ProductionBomNewContent() {
  const { t } = useTranslation();
  const { merchantInventoryTypes, merchantId } = useOperatorData();
  const inventoryTypes = (merchantInventoryTypes || []).map(mit => mit.inventory_type).filter(Boolean);
  const productService = useOperatorProductService();

  return (
    <div>
      <PageHeader items={['production', 'production.production_boms', { label: t('shared.production_boms.form.new_title') }]} />
      <ProductionBomEditView
        productionBomService={operatorProductionBomService}
        productService={productService}
        inventoryTypes={inventoryTypes}
        role="operator"
        merchantId={merchantId}
      />
    </div>
  );
}

export default function OperatorProductionBomNew() {
  return (
    <MerchantSelect>
      <ProductionBomNewContent />
    </MerchantSelect>
  );
}
